import { Box, Heading, Image, Text } from '@doist/marketist'

import cn from 'clsx'

import css from './scroll-header.module.css'

type ScrollHeaderProps = {
    title: string
    children: React.ReactNode
    spotIllustration?: {
        src: string
        offset?: {
            x?: number
            y?: number
        }
        mobileOffset?: {
            x?: number
            y?: number
        }
    }
}

export function ScrollHeader({ title, children, spotIllustration }: ScrollHeaderProps) {
    const offsetX = spotIllustration?.offset?.x ?? -100
    const offsetY = spotIllustration?.offset?.y ?? -100
    const mobileOffsetX = spotIllustration?.mobileOffset?.y ?? offsetX
    const mobileOffsetY = spotIllustration?.mobileOffset?.y ?? offsetY

    return (
        <Box className={cn(css.container, { 'pbs-96': spotIllustration })}>
            {spotIllustration ? (
                <Image
                    src={spotIllustration.src}
                    width={212}
                    height={180}
                    alt=""
                    className={css.spot}
                    style={{
                        '--offset-x': offsetX,
                        '--offset-y': offsetY,
                        '--offset-mobile-x': mobileOffsetX,
                        '--offset-mobile-y': mobileOffsetY,
                    }}
                />
            ) : null}
            <Heading level="2" size="major-lg" className={cn(css.heading, 'mbe-24 md-mbe-32')}>
                {title}
            </Heading>
            <Text size="body-lg" className={cn('mbe-40', css.subheading)}>
                {children}
            </Text>
        </Box>
    )
}
